module.exports = __webpack_public_path__ + "img/1.5d9f5c0d.png";